import { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';

import { complianceService } from '../../../services/complianceService';
import { useSort } from '../../../../shared/hooks/useSort';
import { useAutoSubmitForm } from '../../../../shared/hooks/useAutoSubmitForm';
import { getDateRangeFromParams } from '../../../utils/getDateRangeFromParams/getDateRangeFromParams';
import { getDefaultDateRange } from '../../../utils/getDefaultDateRange/getDefaultDateRange';
import { setRouteParams } from '../../../../shared/utils/angularUtils';

export const useCustomerComplianceHistory = ({
  customerId,
  customerRegistrationDate,
  persistDatesInUrl = false,
}) => {
  const [averageComplianceInfo, setAverageComplianceInfo] = useState(null);
  const [complianceHistory, setComplianceHistory] = useState([]);
  const [consumptionInfo, setConsumptionInfo] = useState(null);
  const [isShowConsumptionWidget, setShowConsumptionWidget] = useState(false);
  const { sortedData: sortedComplianceHistory, sortMethods } = useSort({
    data: complianceHistory,
    sortTypeConfig: { date: 'DATE' },
    dateFormat: 'MM.DD.YYYY',
    defaultSortInfo: { fieldName: 'date', direction: 'DESC' },
  });

  const dateRange = persistDatesInUrl
    ? getDateRangeFromParams(customerRegistrationDate)
    : getDefaultDateRange(customerRegistrationDate);

  const formMethods = useForm({ defaultValues: dateRange });
  const { handleSubmit, watch, getValues } = formMethods;

  const getCustomerComplianceHistory = async (params) => {
    const { avg, items } = await complianceService.getCustomerComplianceHistory(
      customerId,
      params,
    );

    setAverageComplianceInfo(avg);
    setComplianceHistory(items);
  };

  const getConsumptionInfo = async (consumptionParams) => {
    const info = await complianceService.getCustomerConsumptionInfo(
      customerId,
      'DATE',
      consumptionParams,
    );

    setConsumptionInfo(info);
  };

  const handleOpenConsumptionWidget = async () => {
    const data = getValues();
    await getConsumptionInfo(data);

    setShowConsumptionWidget(true);
  };

  const handleCloseConsumptionWidget = () => {
    setConsumptionInfo(null);
    setShowConsumptionWidget(false);
  };

  const toggleShowConsumptionWidget = () => {
    if (isShowConsumptionWidget) {
      handleCloseConsumptionWidget();
    } else {
      handleOpenConsumptionWidget();
    }
  };

  useEffect(() => {
    getCustomerComplianceHistory(dateRange);
  }, []);

  const onSubmit = handleSubmit((data) => {
    getCustomerComplianceHistory(data);
    if (isShowConsumptionWidget) {
      getConsumptionInfo(data);
    }

    if (persistDatesInUrl) {
      setRouteParams(data);
    }
  });

  useAutoSubmitForm(onSubmit, watch);

  const complianceFields = {
    sortedComplianceHistory,
    averageComplianceInfo,
    sortMethods,
  };
  const consumptionFields = {
    consumptionInfo,
    isShowConsumptionWidget,
    toggleShowConsumptionWidget,
  };

  return {
    formMethods,
    complianceFields,
    consumptionFields,
  };
};
